// src/components/ToolNavigator.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

const ToolNavigator = ({ currentImage }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    // Define your available tools and their routes here
    const tools = [
        { key: "stay_here", label: "tools.stayHere", path: null },
        { key: "sharpen", label: "tools.sharpen", path: "/tools/Sharpen-Image" }, // Adjust path to your actual router path
        { key: "remove_bg", label: "tools.removeBg", path: "/tools/Remove-Background" },
        { key: "add_text", label: "tools.addText", path: "/tools/Add-Text-to-Image" },
        { key: "enhance_color", label: "tools.enhance", path: "/tools/Enhance-Colors" },
        { key: "denoise", label: "tools.denoise", path: "/tools/Denoise-Image" },
        { key: "resize", label: "tools.resize", path: "/tools/Resize-Image" },
        { key: "crop", label: "tools.crop", path: "/tools/Crop-Image" },
        { key: "round", label: "tools.round", path: "/tools/Round-Image" },
        { key: "convert_image", label: "tools.convertImage", path: "/tools/Convert-Image" },
        { key: "metadata_image", label: "tools.metadataImage", path: "/tools/Display-Metadata" },



        
        // Add placeholders for future tools
        //{ key: "resize", label: "tools.resize", path: "/image-tools/resize" },
        //{ key: "enhance", label: "tools.enhance", path: "/image-tools/enhance" },
    ];

    const handleToolChange = (e) => {
        const selectedKey = e.target.value;
        const selectedTool = tools.find(t => t.key === selectedKey);

        if (selectedTool && selectedTool.path) {
            // NAVIGATE AND PASS IMAGE DATA
            navigate(selectedTool.path, { 
                state: { 
                    transferredImage: currentImage, // This is the base64 string
                    fromTool: true 
                } 
            });
        }
    };

    return (
        <div className="mt-6 bg-slate-50 p-4 rounded-lg border border-slate-200 flex flex-col md:flex-row items-center gap-4">
            <div className="flex items-center gap-2 text-slate-700 font-medium">
                <ArrowRight size={20} className="text-brand-orange" />
                <span>{t('common.processWithAnotherTool')}:</span>
            </div>
            
            <select 
                className="flex-1 w-full md:w-auto p-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-brand-orange focus:outline-none"
                onChange={handleToolChange}
                defaultValue="stay_here"
            >
                {tools.map(tool => (
                    <option key={tool.key} value={tool.key}>
                        {t(tool.label)}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ToolNavigator;